import Icon from '../components/Icon.vue'

Icon.register({
  'utensil-spoon': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M480.1 31.9C425.1-23.2 315.2-2.6 252.3 60.4 203 109.7 197.2 170.4 223.5 220.8L9 413.2C-2.6 423.7-3.1 441.7 8 452.7L59.3 504C70.3 515 88.4 514.5 98.8 502.9L291.2 288.5C341.6 314.8 402.3 309 451.6 259.7 514.6 196.8 535.2 86.9 480.1 31.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/utensil-spoon.js
// module id = LDiX
// module chunks = 144